import { router } from "expo-router";
import { useRef } from "react";
import { View } from "react-native";
import { Hide, mq } from "react-native-unistyles";

import GlassView from "$src/core/components/atoms/GlassView";
import Icon from "$src/core/components/atoms/Icon";
import type { ModalRef } from "$src/core/components/atoms/Modal/types";
import Pressable from "$src/core/components/atoms/Pressable";
import ActionsModal from "$src/core/components/molecules/ActionsModal/ActionsModal";
import useTranslation from "$src/core/hooks/use-translation";
import type { IconName } from "$src/core/models/icon";

import $ from "./StackHeader.styles";

const HeaderLeft = () => {
  const { t } = useTranslation();

  const handlePress = () => {
    if (router.canGoBack()) {
      router.back();
    } else {
      router.navigate("/");
    }
  };

  return (
    <Pressable
      style={$.button}
      onPress={handlePress}
      hitSlop={6}
      accessibilityRole="button"
      accessibilityLabel={t("COMMON/BACK")}
      accessibilityHint={t("COMMON/BACK/CTA/HINT")}
    >
      <GlassView style={$.glass}>
        <Icon name="chevron-left" style={$.buttonIcon} />
      </GlassView>
    </Pressable>
  );
};

const HeaderRight = ({ right }: { right: RightAction[] }) => {
  const { t } = useTranslation();

  const actionsModalRef = useRef<ModalRef | null>(null);

  return (
    <>
      <Pressable
        style={$.button}
        accessibilityRole="button"
        accessibilityLabel={t("COMMON/MORE_ACTIONS")}
        onPress={() => actionsModalRef.current?.present()}
        hitSlop={8}
      >
        <GlassView style={$.glass}>
          <Icon name="more" style={$.buttonIcon} />
        </GlassView>
      </Pressable>

      <ActionsModal
        ref={actionsModalRef}
        actions={right}
        title={t("COMMON/MORE_ACTIONS")}
      />
    </>
  );
};

export type LeftAction = "back";

export type RightAction = {
  name: string;
  icon: IconName;
  title: string;
  onPress: () => void;
};

type Props = {
  left?: LeftAction | undefined;
  right?: RightAction[] | undefined;
};

const StackHeader = ({ left, right }: Props) => (
  <Hide mq={mq.only.width("lg")}>
    <View style={$.container}>
      <View style={$.headerLeft}>{left === "back" && <HeaderLeft />}</View>

      <View style={$.headerCenter} />

      <View style={$.headerRight}>
        {!!right?.length && <HeaderRight right={right} />}
      </View>
    </View>
  </Hide>
);

export default StackHeader;
